var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('cash-hero-header'),_c('home-easy-step'),_c('home-product-section'),_c('home-eligible'),_c('home-why-us-section'),_c('home-rating-and-recommendation'),_c('v3-cash-hero-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }